/**
 * Create gtm
 * @param {string} source source for GTM
 * @param {string} gtmAttribute gtmAttribute
 * @returns {string} An data-spectate-product value string
 */
export const getGtm = (source, gtmAttribute) => {
    return `${source};${source}-carousel;${gtmAttribute}`;
};

/**
 * Create gtm value for sport link carousel
 * @param {string} source source for GTM
 * @param {string} url icon url
 * @returns {string} An data-spectate-product value string
 */
export const getGtmLink = (source, url) => {
    let gtmUrl = url.replace('/', '');
    const hashPos = gtmUrl.indexOf('#');

    gtmUrl = hashPos >= 0 ? gtmUrl.substring(0, hashPos) : gtmUrl;

    return getGtm(source, gtmUrl);
};
